import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=fcd28a20&scoped=true&"
import script from "./userDetails.vue?vue&type=script&lang=js&"
export * from "./userDetails.vue?vue&type=script&lang=js&"
import style0 from "./userDetails.vue?vue&type=style&index=0&id=fcd28a20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd28a20",
  null
  
)

export default component.exports